// Select - 拜访间隔
export const VISIT_INTERVAL_OPTIONS = [
  {
    label: '0-7',
    value: '0-7',
  },
  {
    label: '8-15',
    value: '8-15',
  },
  {
    label: '16-30',
    value: '16-30',
  },
  {
    label: '30以上',
    value: '30',
  },
  {
    label: '从未拜访',
    value: '1000',
  },
];

// 客户搜索输入框数据内容所属类型
const customerSearchInputTypes = ['客户名称', '客户编号', '最终客户', '业务员', '创建人'];
export const CUSTOMER_SEARCH_INPUT_OPTIONS = customerSearchInputTypes.map((label, index) => ({
  label,
  value: index + 1,
}));
